// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/reset.css'
import './assets/css/common.css'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
 
//引入样式
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper, /* { 全局组件的默认选项 } */)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
    //预编译渲染
    mounted () {
      document.dispatchEvent(new Event('render-event')) // 预渲染
     //上面一行注释，用下面这行
     // document.dispatchEvent(new Event('custom-render-trigger')) // 预渲染
   },
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js